import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';

type RequiredFieldProps = {
  checkForErrors: boolean;
  label?: string;
  value: any;
  className?: string;
  children: any;
};

export const RequiredField = (props: RequiredFieldProps) => {
  const { checkForErrors, label, value, children, className } = props;

  return (
    <FormControl className={className} fullWidth required error={checkForErrors && !value}>
      {label && <InputLabel margin="dense">{label}</InputLabel>}
      {React.cloneElement(children, { value })}
      {checkForErrors && !value && <FormHelperText>Required</FormHelperText>}
    </FormControl>
  );
};
RequiredField.defaultProps = {
  label: undefined,
  className: undefined,
};
